import { computed, Ref } from "@vue/composition-api";
import { ContentPurchase } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { PurchaseInfo, PurchaseResponse } from "@/payments/types";
import { ERRORS, EVENTS } from "@/const";

interface IOneTimePurchase {
  success: boolean;
  response?: PurchaseResponse;
  purchaseDetails?: ContentPurchase;
}

export default function useCreatorServicesPurchase(service: Ref<CreatorService | null>) {
  const purchase = async (): Promise<IOneTimePurchase> => {
    if (!service.value) return { success: false };
    let success = false;
    let contentPurchaseResponse: ContentPurchase | undefined = undefined;
    try {
      providers.CreatorServicesProvider.setReceiveErrors(false);
      contentPurchaseResponse = await providers.CreatorServicesProvider.purchase({ id: service.value.id });
      success = true;
    } catch (e) {
      handleRequestError(e, [
        {
          comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
          onSuccessCB: () => emitter.emit(EVENTS.BALANCE_REFILL_SHOW),
        },
      ]);
    }
    return {
      success,
      purchaseDetails: contentPurchaseResponse,
    };
  };

  const purchaseInfoDetails = computed<PurchaseInfo>(() => ({
    amount: formatMoneyString(service.value?.price ?? 0),
    paymentMethod: "balance",
    purchaseType: "one_time",
  }));

  return {
    purchase,
    purchaseInfoDetails,
  };
}
